export const invoiceItemsConstants = {
  FETCH_COUNT_REQUEST: 'INVOICE_ITEMS_COUNT_FETCH_REQUEST',
  FETCH_COUNT_SUCCESS: 'INVOICE_ITEMS_COUNT_FETCH_SUCCESS',
  FETCH_COUNT_FAILURE: 'INVOICE_ITEMS_COUNT_FETCH_FAILURE',
  FETCH_REQUEST: 'INVOICE_ITEMS_FETCH_REQUEST',
  FETCH_SUCCESS: 'INVOICE_ITEMS_FETCH_SUCCESS',
  FETCH_FAILURE: 'INVOICE_ITEMS_FETCH_FAILURE',
};
